module.exports = __webpack_public_path__ + "static/img1-6253c1883f6a386fb17cfc78cb7c5c98.jpg";